import * as React from 'react';
import { Edit, EditProps, NumberInput, SelectInput, SimpleForm, TextInput } from 'react-admin';
import { CustomFileInput } from '../components/CustomFileInput';
import { ETrainingType } from '../enums';

export const TrainingMenuEdit = (props: EditProps): React.ReactElement => {
	return (
		<Edit {...props} undoable={false}>
			<SimpleForm>
				<NumberInput step={1} source="id" label="#" disabled/>
				<TextInput step={1} source="note" label="NOTE"/>
				<CustomFileInput step={1} source="menuUrl" label="MENU_FILE"/>
				<SelectInput step={1} source="type" label="TYPE" choices={Object.keys(ETrainingType).map(key => ({
					id: key,
					name: ETrainingType[key]
				}))}/>
				<NumberInput step={1} source="fromBMR" label="FROM_BMR"/>
				<NumberInput step={1} source="toBMR" label="TO_BMR"/>
			</SimpleForm>
		</Edit>
	);
};
